import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../../../config/route-paths';
import { buildKaercherLogoutUrl } from '../../utils/buildKaercherLogoutUrl';

export const LogoutCallback = (): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();

    const kaercherLogoutUrl = buildKaercherLogoutUrl();

    if (kaercherLogoutUrl) {
      window.location.replace(kaercherLogoutUrl);
      return;
    }

    navigate(RoutePaths.LOGIN, { replace: true });
  }, [navigate]);

  return <></>;
};
